/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Compare_Users_StarterInputs */



/**
* | output |
* | --- |
* | "1" |
*
* @param {Signup_Compare_Users_StarterInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_compare_users_starter = /** @type {((inputs?: Signup_Compare_Users_StarterInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Compare_Users_StarterInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("1")
	if (locale === "de") return /** @type {LocalizedString} */ ("1")
	if (locale === "it") return /** @type {LocalizedString} */ ("1")
	if (locale === "ru") return /** @type {LocalizedString} */ ("1")
	if (locale === "es") return /** @type {LocalizedString} */ ("1")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("1")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1")
	if (locale === "hi") return /** @type {LocalizedString} */ ("1")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("1")
	return /** @type {LocalizedString} */ ("1")
});